export interface Logger {
    log: (name: string, properties?: { [key: string]: string | boolean | number }) => void;
}

let logger: Logger;

export function setLogger(newLogger: Logger): void {
    logger = newLogger;
}

export function getLogger(): Logger {
    return logger;
}
